<template>
  <Banner></Banner>
  <CityList></CityList>
</template>
<script>
import Banner from '@/components/Banner.vue'
import CityList from '@/components/CityList.vue'
export default {
  components: {
    Banner,
    CityList
  },
  data () {
    return {}
  },
  methods: {},
  created () {}
}
</script>
